import { createSelector, OutputSelector } from "reselect"
// @ts-expect-error: Flow to TS migration.
import { matchRoutes, Route, MatchedRoutes, RouterProps } from "react-router-config"

const baseMatchedRoutesSelector: OutputSelector<
  RouterProps,
  undefined,
  MatchedRoutes
> = createSelector(
  (props) => props.route,
  (props) => props.location.pathname,
  (route, pathname) => matchRoutes([route], pathname),
)

// @ts-expect-error: Flow to TS migration.
export const matchedRoutesSelector: OutputSelector<
  RouterProps,
  undefined,
  Route[]
  // @ts-expect-error: Flow to TS migration.
> = createSelector(baseMatchedRoutesSelector, (routes) => routes.map((r) => r.route))

// @ts-expect-error: Flow to TS migration.
export const paramsFromLastMatchedRouteSelector: OutputSelector<
  RouterProps,
  undefined,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  {
    [key: string]: string | null | undefined
  }
  // @ts-expect-error: Flow to TS migration.
> = createSelector(baseMatchedRoutesSelector, (routes) => routes[routes.length - 1].match.params)
